/*
 * Adds the free Welcome Kit whenever the cart holds a Myoform Pro
 * subscription without one, and takes back a gifted kit once nothing in the
 * cart earns it, so checkout never charges for it. Config comes from
 * snippets/myoform-welcome-kit-auto.liquid.
 */
(function () {
  var configEl = document.querySelector('[data-mwk-config]');
  if (!configEl || !window.fetch) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var kitId = Number(config.welcomeKit);
  var proIds = (config.proProducts || []).map(Number);
  var memberIds = (config.memberProducts || []).map(Number).filter(Boolean);
  if (!kitId || !proIds.length) return;

  var nativeFetch = window.fetch.bind(window);
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var OWN_HEADER = 'X-Myoform-Welcome-Kit';
  var timer = null;
  var running = false;
  var pending = null;

  function isSubscriptionOf(item, ids) {
    return Boolean(item.selling_plan_allocation) && ids.indexOf(item.product_id) > -1;
  }

  function isGiftedKit(item) {
    return item.variant_id === kitId && item.properties && item.properties._gift === 'welcome-kit';
  }

  function cartRequest(url, body) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    headers[OWN_HEADER] = '1';
    return nativeFetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body) }).then(function (response) {
      if (!response.ok) throw new Error('Welcome kit cart update failed');
      return response.json();
    });
  }

  function render(state) {
    if (document.body.classList.contains('template-cart') || /^\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !state || !state.sections || typeof drawer.getSectionsToRender !== 'function') return;
    drawer.getSectionsToRender().forEach(function (section) {
      var html = state.sections[section.id];
      var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!html || !target) return;
      var source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
      if (source) target.innerHTML = source.innerHTML;
    });
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    drawer.classList.remove('is-empty');
  }

  function reconcile(allowRemoval) {
    if (running) {
      pending = pending || allowRemoval;
      return;
    }
    running = true;

    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var hasPro = items.some(function (item) {
          return isSubscriptionOf(item, proIds);
        });
        var hasKit = items.some(function (item) {
          return item.variant_id === kitId;
        });

        if (hasPro && !hasKit) {
          return cartRequest('/cart/add.js', {
            items: [{ id: kitId, quantity: 1, properties: { _gift: 'welcome-kit' } }]
          }).then(render);
        }

        if (!allowRemoval) return null;
        var earnsKit = items.some(function (item) {
          return isSubscriptionOf(item, proIds) || isSubscriptionOf(item, memberIds);
        });
        var gifted = items.filter(isGiftedKit);
        if (earnsKit || !gifted.length) return null;

        var updates = {};
        gifted.forEach(function (item) {
          updates[item.key] = 0;
        });
        return cartRequest('/cart/update.js', { updates: updates }).then(render);
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (pending !== null) {
          var next = pending;
          pending = null;
          reconcile(next);
        }
      });
  }

  function schedule(allowRemoval) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      reconcile(allowRemoval);
    }, 250);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var headers = (init && init.headers) || {};
    var own = headers instanceof Headers ? headers.get(OWN_HEADER) : headers[OWN_HEADER];
    var request = nativeFetch(input, init);
    if (!own && CART_WRITE.test(url)) {
      request.then(function (response) {
        if (response.ok) schedule(!/\/cart\/add/.test(url));
      }, function () {});
    }
    return request;
  };

  reconcile(true);
})();
